import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Actions, Store, ofActionErrored, ofActionSuccessful } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { LoginRequest } from 'src/app/modules/login/models/login-request.model';
import { AuthActions } from 'src/app/modules/login/store/auth.actions';

@Component({
  selector: 'app-sgc1-middleware',
  templateUrl: './sgc1-middleware.component.html',
  styleUrls: ['./sgc1-middleware.component.scss']
})
export class Sgc1MiddlewareComponent implements OnDestroy {
  private unsubscriber$ = new Subject<void>();
  
  constructor(route: ActivatedRoute,
    public store: Store,
    private actions$: Actions,
    private router: Router
  ) {
    this.tryToProcessResponse(route.snapshot);
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }

  private tryToProcessResponse(route: ActivatedRouteSnapshot) {
    let sessionId = route.queryParams['sessionId'];
    let redirectUrl = route.queryParams['resourceUrl'];
    if(sessionId && redirectUrl) {
      this.store.dispatch(new AuthActions.LoginSGC1(new LoginRequest(sessionId)));
      this.actions$
        .pipe(
          ofActionSuccessful(AuthActions.LoginSuccess),
          takeUntil(this.unsubscriber$)
        )
        .subscribe(() => {
          this.router.navigate([redirectUrl]);
        });

        this.actions$
        .pipe(
          ofActionErrored(AuthActions.LoginSGC1),
          takeUntil(this.unsubscriber$)
        )
        .subscribe(() => {
          this.router.navigate(['/login']);
        });
    } else {
      this.router.navigate(['/login']);
    }
  }
}
